var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.67883C0 6.01589 0.234845 6.28664 0.615817 6.28664C0.788037 6.28664 0.955038 6.1927 1.10116 6.06562L1.62826 5.59595V10.6297C1.62826 11.4861 2.11883 12 2.95383 12H10.0201C10.8551 12 11.3456 11.4861 11.3456 10.6297V5.57385L11.8988 6.06562C12.045 6.1927 12.212 6.28664 12.3894 6.28664C12.7391 6.28664 13 6.05456 13 5.68988C13 5.47991 12.9165 5.3031 12.7599 5.16496L11.3456 3.90515V1.49603C11.3456 1.24738 11.1943 1.08162 10.9595 1.08162H10.114C9.87916 1.08162 9.71738 1.24738 9.71738 1.49603V2.45747L7.3324 0.335674C6.83139 -0.111891 6.18426 -0.111891 5.67804 0.335674L0.240064 5.16496C0.0835006 5.30862 0 5.49649 0 5.67883ZM7.99518 7.17624C7.99518 6.91654 7.83862 6.75078 7.59334 6.75078H5.4171C5.1666 6.75078 5.00482 6.91654 5.00482 7.17624V10.7347H3.31393C2.99558 10.7347 2.81815 10.5468 2.81815 10.2042V4.53505L6.24689 1.49603C6.40867 1.34684 6.59655 1.34684 6.76355 1.49603L10.1558 4.50742V10.2042C10.1558 10.5468 9.97832 10.7347 9.65998 10.7347H7.99518V7.17624Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9e5b8e5a59c8e231de51428b6e234d6b.svg";
export { ForwardRef as ReactComponent };